// HTML set configuration
export const SYSTEM_CONFIG: {
  apiBaseUrl?: string;
  frontEndBaseUrl?: string; // to allow override, assets base url
} = (window as any).__config__ || {};
